/* compact pill switch — sized to its labels, not stretched; wraps to a second row rather than hide an option */
.switch {
  display: inline-flex;
  align-self: flex-start;
  flex-wrap: wrap;
  max-width: 100%;
  gap: 4px;
  padding: 4px;
  border-radius: 22px;
  background: var(--color-surface-2);
}
.item {
  flex-shrink: 0;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  min-height: 40px;
  padding: 0 var(--space-3);
  border: 0;
  border-radius: var(--radius-full);
  background: transparent;
  color: var(--color-text-muted);
  font: inherit;
  font-size: var(--text-sm);
  font-weight: 800;
  cursor: pointer;
}
.active {
  background: var(--color-surface);
  color: var(--color-text);
  box-shadow: var(--shadow-sm);
}
.item:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}
.count {
  display: inline-grid;
  place-items: center;
  min-width: 24px;
  height: 24px;
  padding: 0 6px;
  border-radius: var(--radius-full);
  background: var(--color-text);
  color: var(--color-bg);
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 800;
}
.zero {
  background: var(--color-border);
  color: var(--color-text-muted);
}
